function VisaType({ visaTypes = [], selectedVisaType, onSelectVisaType }) {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900">
        Step 2: Select Visa Type
      </h3>

      {visaTypes.length === 0 ? (
        <p className="text-gray-500">No visa types available</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {visaTypes.map((type) => {
            const isSelected = selectedVisaType?.id === type.id;

            return (
              <button
                key={type.id}
                onClick={() => onSelectVisaType(type)}
                className={`p-5 rounded-xl border-2 text-left transition-all ${
                  isSelected
                    ? "border-blue-600 bg-blue-50 shadow-md"
                    : "border-gray-200 hover:border-gray-300 hover:shadow-sm"
                }`}
              >
                <h4 className="text-sm font-bold text-gray-900">
                  {type.name}
                </h4>

                <div className="mt-2 text-sm text-gray-600 space-y-1">
                  <div>Processing Time: {type.processing_time}</div>
                  <div>Validity: {type.validity}</div>
                  <div>Entries Allowed: {type.entries_allowed}</div>
                </div>
              </button>
            );
          })}
        </div>
      )}

      
    </div>
  );
}

export default VisaType;
